var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ScheduledOutcome } from "@/components/timezones/ScheduledOutcome";
/** Explanations that read the same: the same outcome, decided by the same check. */
export var groupByReason = function (outcomes) {
    var _a;
    var groups = new Map();
    for (var _i = 0, outcomes_1 = outcomes; _i < outcomes_1.length; _i++) {
        var outcome = outcomes_1[_i];
        var key = "".concat(outcome.explanation.outcome, "|").concat(outcome.explanation.deciding);
        groups.set(key, __spreadArray(__spreadArray([], ((_a = groups.get(key)) !== null && _a !== void 0 ? _a : []), true), [outcome], false));
    }
    return Array.from(groups.values());
};
/**
 * The predicted outcome of one scheduled opening or closing. An event-wide
 * row has one per election: the elections are grouped by outcome and deciding
 * check, each group with its count and the reason of its first election.
 * Times are in the row's zone.
 */
export var RowOutcome = function (_a) {
    var outcomes = _a.outcomes, zone = _a.zone;
    var t = useTranslation().t;
    var several = outcomes.length > 1;
    return (_jsx(Stack, { spacing: 1, children: groupByReason(outcomes).map(function (group) { return (_jsxs(Stack, { spacing: 0.25, children: [_jsx(ScheduledOutcome, { explanation: group[0].explanation, zone: zone }), several ? (_jsx(Typography, { variant: "caption", color: "text.secondary", children: t("lifecycle.schedule.outcomeElections", {
                        count: group.length,
                        total: outcomes.length,
                    }) })) : null] }, "".concat(group[0].explanation.outcome, "-").concat(group[0].explanation.deciding))); }) }));
};
